import { Box, Tab as MuiTab, Tabs as MuiTabs } from '@mui/material';

export interface TabItem {
    label: string;
    value: string;
}

interface TabsProps {
    tabs: TabItem[];
    value: string;
    onChange: (value: string) => void;
    fullWidth?: boolean;
}

const Tabs = ({ tabs, value, onChange, fullWidth = true }: TabsProps) => {
    return (
        <Box sx={{ borderBottom: 'none' }}>
            <MuiTabs
                value={value}
                onChange={(_, newValue) => onChange(newValue)}
                variant={fullWidth ? 'fullWidth' : 'standard'}
                TabIndicatorProps={{ style: { display: 'none' } }}>
                {tabs.map((tab) => (
                    <MuiTab
                        key={tab.value}
                        value={tab.value}
                        label={tab.label}
                        sx={(theme) => ({
                            fontWeight: 'bold',
                            textTransform: 'none',
                            color: 'inherit',
                            borderBottom:
                                value === tab.value
                                    ? `4px solid ${theme.palette.primary.main}`
                                    : '4px solid transparent',
                            borderRadius: 0,
                            minHeight: '48px',
                        })}
                    />
                ))}
            </MuiTabs>
        </Box>
    );
};

export default Tabs;
